import { Box } from '@material-ui/core'
import React from 'react'
import { Input, InputProps, Typography } from 'src/components/atoms'

type FormRowProps = {
  label: string
} & InputProps

export const FormRow = ({ label, ...otherProps }: FormRowProps) => {
  return (
    <Box width="100%">
      <Box sx={{ mb: '6px' }}>
        <Typography variant="caption" fontSize="s" fontWeight="bold">
          {label}
        </Typography>
      </Box>
      <Input {...otherProps} />
    </Box>
  )
}
